function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const revealFn = () => {
    const EL_VISIBLE = 200;
    const revealElements = document.querySelectorAll('.reveal');

    revealElements.forEach((el) => {
      const elTop = el.getBoundingClientRect().top;
      el.classList.toggle('active', (elTop < window.innerHeight - EL_VISIBLE));
    })
  }
  window.addEventListener('scroll', revealFn);
  revealFn();
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger());
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger());
}
